import React, { Component } from 'react';
import { ConfigProvider, Result } from 'antd';
import zhCN from 'antd/es/locale/zh_CN';
import {
  BrowserRouter as Router,
  Redirect,
  Switch,
  Route,
} from 'react-router-dom';
import { Helmet } from 'react-helmet';

import routes from './routers';

// 兜底校验文案：任何表单规则未写 message 时也显示中文，而不是英文
// "Validation error on field 'xxx'"
const validateMessages = {
  default: '${name}格式不正确',
  required: '请填写${name}',
  whitespace: '${name}不能为空',
  types: {
    string: '${name}不是有效的字符串',
    number: '${name}不是有效的数字',
    email: '${name}不是有效的邮箱',
  },
  string: {
    min: '${name}长度不能低于${min}位',
    max: '${name}长度不能超过${max}位',
  },
};

class App extends Component {
  state = {
    hasError: false,
  };

  static getDerivedStateFromError(error) {
    // 更新 state 使下一次渲染能够显示降级后的 UI
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // 你同样可以将错误日志上报给服务器
  }

  render() {
    if (this.state.hasError) {
      return (
        <Result
          status="500"
          title="系统发生了错误..."
          // subTitle="Sorry, something went wrong."
        />
      );
    }
    return (
      <ConfigProvider locale={zhCN} form={{ validateMessages }}>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            position: 'relative',
            minHeight: '100vh',
          }}
        >
          <Helmet title="超图杯·河南工业大学校赛报名系统" />
          <Switch>
            {routes.map((route, index) => {
              if (route.exact) {
                return (
                  <Route
                    key={index}
                    path={route.path}
                    exact
                    render={(props) => (
                      <route.component {...props} routes={route.routes} />
                    )}
                  />
                );
              } else {
                return (
                  <Route
                    key={index}
                    path={route.path}
                    render={(props) => (
                      <route.component {...props} routes={route.routes} />
                    )}
                  ></Route>
                );
              }
            })}
          </Switch>
        </div>
      </ConfigProvider>
    );
  }
}

export default App;
